// src/pages/en/Terms_en.js
import React from "react";
import { Link } from "react-router-dom";
import "../Terms.css";

function Terms() {
  return (
    <div className="terms-page" lang="en">
      <header className="app-bar" role="banner">
        <div className="app-bar__inner">
          <Link to="/en" className="brand-link" aria-label="Go to English home">
            TooLoves
          </Link>
        </div>
      </header>

      <main id="content" role="main" className="container" aria-labelledby="terms-title">
        <article className="generator-card terms-card" aria-labelledby="terms-title">
          <header className="terms-header">
            <h1 id="terms-title" className="card-title">TooLoves.net Terms of Use</h1>
            <p className="card-subtitle terms-updated">
              Last updated:
              <time dateTime="2025-10-22"> October 22, 2025 (KST)</time>
            </p>
          </header>

          <section className="terms-section">
            <p>
              These Terms of Use (the "Terms") set out the rights, obligations, and responsibilities that
              members and visitors ("Users") must observe when using TooLoves.net (the "Site"),
              operated by the operator of TooLoves.net (the "Operator"). By using the Site, Users are
              deemed to have agreed to these Terms.
            </p>
          </section>

          <section className="terms-section" id="purpose">
            <h2 className="section-title">1. Purpose of Use</h2>
            <p>
              TooLoves.net provides various online tools such as a QR code generator, image
              watermarking, and an AI photo EXIF extractor to help Users perform digital tasks quickly
              and conveniently.
            </p>
          </section>

          <section className="terms-section" id="user-duties">
            <h2 className="section-title">2. User Obligations</h2>
            <ol>
              <li>Users must comply with applicable laws and these Terms when using the Site.</li>
              <li>Users must not abuse the Site’s features or use the Site for illegal or harmful purposes.</li>
              <li>Users must not infringe upon the rights of others (including copyrights, portrait rights, and personal information).</li>
              <li>
                The following acts are strictly prohibited:
                reverse engineering; circumvention or bypassing of technical measures; automated data collection;
                interference with the service; security breaches; distribution of malware; posting illegal content; impersonation;
                and generating excessive requests that cause overload.
              </li>
            </ol>
          </section>

          <section className="terms-section" id="service-changes">
            <h2 className="section-title">3. Provision and Changes to the Service</h2>
            <ol>
              <li>The Operator may change, suspend, or terminate the services as necessary to ensure stable operation of the Site.</li>
              <li>If a User continues to use the services after changes are made, the User is deemed to have agreed to the revised Terms.</li>
              <li>
                If a User violates these Terms or applicable laws, or if deemed necessary for site operation,
                the Operator may restrict or block the User’s access to the services without separate consent or notice.
              </li>
            </ol>
          </section>

          <section className="terms-section" id="copyright">
            <h2 className="section-title">4. Copyright</h2>
            <ol>
              <li>All content posted on the Site (text, images, code, etc.) is owned by the Operator.</li>
              <li>
                The copyright in all information and content generated, uploaded, transmitted, or provided by
                Users via the services ("User-Generated Content") remains with the respective Users.
              </li>
              <li>
                Users may use content for personal, non-commercial purposes only, and distribution other than via the Site’s
                built-in sharing buttons is prohibited.
              </li>
            </ol>
          </section>

          <section className="terms-section" id="liability">
            <h2 className="section-title">5. Limitation of Liability</h2>
            <ol>
              <li>The Operator does not warrant the accuracy, completeness, safety, or harmlessness of data generated by Users through the Site.</li>
              <li>To the extent permitted by law, the Operator shall not be liable for any damages arising from the use of the Site.</li>
              <li>
                Users bear sole civil and criminal liability for User-Generated Content, and the Operator assumes no responsibility in this regard.
              </li>
            </ol>
          </section>

          <section className="terms-section" id="privacy">
            <h2 className="section-title">6. Privacy</h2>
            <p>
              Personal information collected during use of the Site is handled safely in accordance with the{" "}
              <Link to="/en/privacy" className="link" aria-label="View Privacy Policy">Privacy Policy</Link>.
            </p>
          </section>

          <section className="terms-section" id="changes">
            <h2 className="section-title">7. Changes to the Terms</h2>
            <p>The Operator may amend these Terms as necessary, and the revised Terms will be announced on the Site or otherwise notified.</p>
            <p>Continued use of the Site after changes constitutes acceptance of the revised Terms.</p>
          </section>

          <section className="terms-section" id="disputes">
            <h2 className="section-title">8. Dispute Resolution</h2>
            <p>
              These Terms and any disputes related to the services are governed by the laws of the Republic of Korea,
              and the court having jurisdiction over the Operator’s domicile shall be the court of first instance.
            </p>
          </section>

          <section className="terms-section" id="contact">
            <h2 className="section-title">9. Contact</h2>
            <p>
              For service inquiries, please contact{" "}
              <a
                href="mailto:helptooloves@gmail.com"
                className="mailto-link"
                aria-label="Send email to helptooloves@gmail.com"
              >
                helptooloves@gmail.com
              </a>.
            </p>
          </section>

          <div className="terms-actions">
            <Link to="/en" className="btn" aria-label="Go to English home">
              Back to English Home
            </Link>
          </div>
        </article>
      </main>

      <footer className="footer" role="contentinfo">© 2025 TooLoves. All rights reserved.</footer>
    </div>
  );
}

export default Terms;